import React from 'react';
import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import './css/index.scss';

export default function CtMedia(props) {
  const { data, card, radius, horizon, shadow, className, component:Component='a' } = props;

  const cls = classNames(
    'material-media',
    card ? 'material-media--card' : '',
    radius ? 'material-media--radius' : '',
    horizon ? 'material-media--horizon' : '',
    shadow ? 'material-media--shadow' : '',
    className,
  );

  return (
    <Component
      className={cls}
      href={data.href}
      target="_blank"
      rel="noreferrer"
    >
      <div className="material-media__img">
        <img src={data.img} alt="" />
        <span>{data.title}</span>
      </div>

      <div className="material-media__info">
        {data.title && (
          <div className={classNames("material-media__info-title")}>
            {data.title}
          </div>
        )}
        {data.desc && (
          <div className="material-media__info-desc">
            <span>{data.desc}</span>
          </div>
        )}
        {data.link && (
          <div className="material-media__info-link">{data.link}</div>
        )}
      </div>
    </Component>
  );
}
CtMedia.propTypes = {
  /**
   * 自定义class
   */
  className: PropTypes.string,
  /**
   * 数据渲染
   */
  data: PropTypes.object,
  /**
   * 卡片分格，开启时带hover效果
   */
  card: PropTypes.bool,
  /**
   * 圆角风格
   */
  radius: PropTypes.bool,
  /**
   * 水平布局
   */
  horizon: PropTypes.bool,
  /**
   * 阴影类型
   */
  shadow: PropTypes.bool,
};
